import { render, staticRenderFns } from "./StudentOrderItemPreview.vue?vue&type=template&id=127e4ffb&scoped=true&"
import script from "./StudentOrderItemPreview.vue?vue&type=script&lang=ts&"
export * from "./StudentOrderItemPreview.vue?vue&type=script&lang=ts&"
import style0 from "./StudentOrderItemPreview.vue?vue&type=style&index=0&id=127e4ffb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "127e4ffb",
  null
  
)

export default component.exports